function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
let currencyFormat = window.theme.settings.currencyCodeEnabled ? window.theme.settings.moneyWithCurrencyFormat : window.theme.settings.moneyFormat;

$(document).ready(function() {
  $(".testimonial-custom_row").slick({
      dots: true,
      arrows:false,
      infinite:false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  $(".our-expert_content_grid-list").slick({
    dots: false,
    arrows:true,
    infinite:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
    
  $('.best-products_items-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    dots: true,
    speed: 300,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });

  $(".real-feedback_row").slick({
      dots: false,
      arrows:true,
      infinite:false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // under 768px
          settings: "unslick" // destroys slider
        }
      ]
    });
    $(".process_items-list").slick({
      dots: true,
      arrows:false,
      infinite:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // under 768px
          settings: "unslick" // destroys slider
        }
      ]
    });

    $(".process-sec-list").slick({
      dots: true,
      arrows:false,
      infinite:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // under 768px
          settings: "unslick" // destroys slider
        }
      ]
    });

    $('.corporate_collection_main-grid-item').each(function () {
      var $item = $(this);
      var $media = $item.find('.corporate_collection_main-grid-item_media-list');
      var $nav   = $item.find('.corporate_collection_main-grid-item_nav-list');

      $media.slick({
        dots: false,
        arrows: false,
        infinite: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        swipe: false,
        asNavFor: $nav // pass the actual jQuery object
      });

      $nav.slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: $media // pass the actual jQuery object
      });
    });


  $('.closer-look_item-add_btn').click(function(){
      $('.closer-look_item').removeClass('active');
      $(this).parents('.closer-look_item').addClass('active');
  });
  $('.closer-look_item-close_btn').click(function(){
      $('.closer-look_item').removeClass('active');
  });
  $('.shop-the-look-dots-item').click(function(){
     var index = $(this).attr('index');
     $('.shop-the-look-dots-item').removeClass('is-selected');
     $(`.shop-the-look-dots-item[index="${index}"]`).addClass('is-selected');
  
     $('.shop-the-look-custom_content-item').removeClass('is-selected');
     $(`.shop-the-look-custom_content-item[index="${index}"]`).addClass('is-selected');
  });

  $('.product-block--accordion_title').click(function(){
   $(this).toggleClass('active');
   $(this).next('.product-block--accordion_content').slideToggle();
  });
  $('.shop-the-look-index-block').click(function(){
    $('.shop-the-look-index-block').removeClass('active');
    $(this).addClass('active');
  });
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.shop-the-look-index-block').length) {
      $('.shop-the-look-index-block').removeClass('active');
    }
  });

  $("body").on("click", ".new-offer-copy_text", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.text("Copied")
      
    setTimeout(function () {
      copy_text.text("Copy");
    }, 1000);
  });

  $('#engraving_text-input').on('input', function () {
    if ($.trim($(this).val()).length > 0) {
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
    } else {
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').hide();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').show();
    }
  });

  $('body').on('click', '#engraving_text-check', function(){
    const engraving_alt = $(this).attr('data-engrave').toLowerCase();
    const product_imgs = $(this).parents('.page-content--product').find('.product__thumb-item');    
    console.log('engraving_alt',engraving_alt);
     
    var current_variant_price = parseInt($(this).closest('.product-single__meta').find('[data-product-price]').attr('val'));
    var current_compare_variant_price = parseInt($(this).closest('.product-single__meta').find('[data-compare-price]').attr('val'));

    var engraving_price = parseInt($(this).attr('price'));
    var engraving_compare_price = parseInt($(this).attr('compare_price'));
    if ($(this).is(':checked')) {
      product_imgs.each(function () {
        const media_alt = $(this).attr('data-alt').toLowerCase();
        console.log(media_alt,'media_alt');
        if (media_alt === engraving_alt) {
          console.log('matchedddd')
          $(this).find('.product__thumb').addClass('is-active');
          $(this).find('.product__thumb').find('.image-wrap__thumbnail').click();
        }
      })      
      $(this).closest('.product-single__meta').find('[data-product-price]').html(formatMoney((current_variant_price + engraving_price), currencyFormat))
      $(this).closest('.product-single__meta').find('[data-compare-price]').html(formatMoney((current_compare_variant_price + engraving_compare_price), currencyFormat))
      if($.trim($('#engraving_text-input').val()).length > 0){
        $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
        $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
      }else{
        $(this).closest('.product-single__meta').find('[data-add-to-cart]').hide();
        $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').show();
      }
    } else {
      $(this).closest('.product-single__meta').find('[data-product-price]').html(formatMoney(current_variant_price, currencyFormat))
      $(this).closest('.product-single__meta').find('[data-compare-price]').html(formatMoney(current_compare_variant_price, currencyFormat))
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
      product_imgs.each(function () {
        $(this).find('.product__thumb[data-index="0"]').find('.image-wrap__thumbnail').click();
        const media_alt = $(this).attr('data-alt').toLowerCase();
        console.log(media_alt,'media_alt');
        if (media_alt === engraving_alt) {
          console.log('matchedddd')
          $(this).find('.product__thumb').removeClass('is-active');          
        }
      }) 
    }  
  });

  $('.gifting-form-thank-you_button').click(function(e){
    e.preventDefault();
   // Trigger PDF download
   var pdflink = $(this).attr('data-href');
    fetch(pdflink)
    .then(resp => resp.blob())
    .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'gifting-catalogue.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    })
    .catch(() => alert('Failed to download file')); 
  });

   $('body').on('click', '.cart__item-sub.cart__item-row', function() {
    $('.cart-payment-summary_mainn').slideToggle();
    $(this).toggleClass('active');
  })

});


function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}

function counterFun() {
  var $counter = $('#counter');
  if (!$counter.length) return;

  if (isPartiallyInView($counter)) {
    $('.count').each(function () {
      var $this = $(this);
      var countTo = parseInt($this.attr('data-count'), 10);

      if (!$this.hasClass('counted')) {
        $this.addClass('counted');
        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              // Add commas while animating
              $this.text(Math.floor(this.countNum).toLocaleString());
            },
            complete: function () {
              // Final value with commas
              $this.text(countTo.toLocaleString());
            }
          }
        );
      }
    });
  } else if (isFullyOutOfView($counter)) {
    // Reset only when fully out of view
    $('.count').each(function () {
      $(this).removeClass('counted').text('0');
    });
  }
}


$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);

$(document).ready(function () {
  $('.process-videos_item-play-btn').on('click', function () {
    var $btn = $(this);
    var $video = $btn.siblings('video')[0];

    // If same video is playing → pause it
    if (!$video.paused && !$video.ended) {
      $video.pause();
      return;
    }

    // Pause all other videos and remove their .active
    $('video').each(function () {
      if (this !== $video) {
        this.pause();
        this.currentTime = 0;
        $(this).siblings('.process-videos_item-play-btn').removeClass('active');
      }
    });

    // Play the clicked video
    $video.play();
  });

  // ✅ Add .active when video starts playing
  $('video').on('play', function () {
    $(this).siblings('.process-videos_item-play-btn').addClass('active');
  });

  // ❌ Remove .active when video pauses or ends
  $('video').on('pause ended', function () {
    $(this).siblings('.process-videos_item-play-btn').removeClass('active');
  });

  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
  
    var targetId = $(this).attr('href');
    var targetElement = $(targetId);
  
    if (targetElement.length) {
      var offsetTop = targetElement.offset().top - 120;
  
      $('html, body').animate({
        scrollTop: offsetTop
      }, 600); // 600ms animation duration
    }
  });

  
  $('.offer-convenience-media_items-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.offer-convenience-content_col-blocks-list',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          }
        }
      ]
  });
  $('.offer-convenience-content_col-blocks-list').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      vertical:true,
      asNavFor: '.offer-convenience-media_items-list',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
            vertical: false,
          }
        }
      ]
  });

  // $('.favorite-character_items-list').slick({
  //       slidesToShow: 8,
  //       slidesToScroll: 1,
  //       autoplay: true,
  //       autoplaySpeed: 1,
  //       speed: 6000,
  //       dots: false,
  //       arrows: false,
  //       cssEase: 'linear',
  //       waitForAnimate: false,
  //       pauseOnFocus: true, 
  //       pauseOnHover: true,
  //       responsive: [
  //           {
  //               breakpoint: 740,
  //               settings: {
  //                   slidesToShow: 3,
  //                   slidesToScroll: 1,
  //               }
  //           }
  //       ]
  //   });

  $('.core-principles_list-item').click(function(){
    $('.core-principles_list-item').removeClass('active');
    $(this).addClass('active');
    $('.core-principles_description').hide();
    
    var activeTab = $(this).attr('data-id');
    $(activeTab).fadeIn();
    return false;
  });

  $('body').on('click', '.product-grid-item-atc', function (e) {
    e.preventDefault();
    this.setAttribute('disabled', 'disabled');
    $(this).addClass('btn--loading');

    var variant_id = parseInt($(this).attr('variant_id'));
    var _this = this;
    console.log('variant_id', variant_id);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      // async: false,
      data: { 
        quantity: 1, 
        id: variant_id
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        
        $(_this).removeAttr('disabled');
        $(_this).removeAttr('aria-busy');
        $(_this).removeClass('loading');
      },
      success: function() {
        $(_this).removeAttr('disabled');
        $(_this).removeClass('btn--loading');
        console.log('success');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    });
  });

  if (window.innerWidth < 768) { // mobile breakpoint
    $('.ideal-size_content-title').click(function () {
      $(this).toggleClass('active');
      $(this).next('.ideal-size_content-box').slideToggle();
    });
  }

  // $('.slider-for').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   fade: true,
  //   asNavFor: '.slider-nav'
  // });
  // $('.logo-with-content_items-list').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   asNavFor: '.slider-for',
    // dots: false, 
    // centerMode:true,
    // variableWidth:true,
    // infinite: true,
    // focusOnSelect: true,
    // autoplay:true,
    // autoplaySpeed: 1000
  // });

  $('.logo-with-content_items-content_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.logo-with-content_items-media_list'
  });
  $('.logo-with-content_items-media_list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay:true,
      infinite: true,
      focusOnSelect: true,
      asNavFor: '.logo-with-content_items-content_list',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          }
        }
      ]
  });

  // document.querySelectorAll('.download-link').forEach(el => {
  //   el.addEventListener('click', function(e) {
  //       e.preventDefault(); 
  //       const fileUrl = this.getAttribute('href');
  //       const fileName = this.getAttribute('download') || 'Catalogue.pdf';

  //       fetch(fileUrl)
  //       .then(resp => resp.blob())
  //       .then(blob => {
  //           const url = window.URL.createObjectURL(blob);
  //           const a = document.createElement('a');
  //           a.href = url;
  //           a.download = fileName;
  //           document.body.appendChild(a);
  //           a.click();
  //           a.remove();
  //           window.URL.revokeObjectURL(url);
  //       })
  //       .catch(() => alert('Failed to download file'));
  //   });
  // });

  $('body').on('click', '.our-expert-video-item-button', function () {
    $(this).hide();
    const video = $(this).parents('.our-expert_content_grid-list_item-video').find('video')[0];
    video.currentTime = 0;
    video.muted = true;
    video.controls = true;
    video.play().catch(err => {
      console.log('Autoplay prevented:', err);
    });
  }) 
  
  $('#engraving_text-input').on('input', function() {
    var inputValue = $(this).val();
    // Regex to match most common emojis and variations
    var emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
    
    if (emojiRegex.test(inputValue)) {
        var sanitizedValue = inputValue.replace(emojiRegex, '');
        $(this).val(sanitizedValue);
    }
  });

  $('body').on('click','.custom-chat-floating-btn', function (){
    $('.floating-chat-widget, .floating-chat-widget-overlay').addClass('active');
  })
  $('body').on('click','.floating-chat-widget-close', function (){
    $('.floating-chat-widget, .floating-chat-widget-overlay').removeClass('active');
  })

  $('.product-list-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
          }
        }
      ]
  });

});
